<template>
  <div class="foot-wrap" :style="`background-color: ${color}`">
    <a class="beian-text" href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">浙ICP备2025147760号-2</a>
    <div class="md-container">
      <h6>联系我们</h6>
      <div class="qrcode-list">
        <div class="qrcode-item">
          <div class="qrcode-img">
            <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/dy.png" alt="抖音">
          </div>
          <div class="qrcode-text">
            <span>抖音</span>
          </div>
        </div>
        <div class="qrcode-item">
          <div class="qrcode-img">
            <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/xhs.png" alt="小红书">
          </div>
          <div class="qrcode-text">
            <span>小红书</span>
          </div>
        </div>
        <div class="qrcode-item">
          <div class="qrcode-img">
            <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/xcx.png" alt="小程序">
          </div>
          <div class="qrcode-text">
            <span>小程序</span>
          </div>
        </div>
        <div class="qrcode-item">
          <div class="qrcode-img">
            <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/gzh.png" alt="公众号">
          </div>
          <div class="qrcode-text">
            <span>公众号</span>
          </div>
        </div>
      </div>
      <p class="contact-tel">
        合伙人热线<br/>
        <a href="tel:400-000-0000">400-891-0589</a>
      </p>

    </div>
  </div>
</template>
<script> 
export default {
  props: {
    color: {
      type: String,
      default: '#fcfbec'
    }
  }
}
</script>
<style lang="less" scoped>
@import "../lib/px2vw";
@media(max-width: 1200px) {
  .foot-wrap {
    width: 100% !important;
    height: auto !important;
    .beian-text{
      font-size: 1.448vw !important;
      color: #7c726b !important;
      line-height: 4.3813vw !important;
      bottom: 0 !important;
    }
    .md-container{
      padding-top: 9.0667vw !important;
      width: 81.47vw !important;
      padding-bottom: 12.267vw !important;
      .contact-tel{
        position: absolute;
        right: 0;
        top: 9.0667vw !important;
        font-size: 4.0vw !important;
        line-height: 4.0vw !important;
      }
      h6{
        text-align: center !important;
        margin-bottom: 4.2vw !important;
        font-size: 4.0vw !important;
        line-height: 4.0vw !important;
        text-align: left !important;
        margin: 0 0 8vw 0 !important;
        padding: 0 !important;
      }
      .qrcode-list{
        width: 100%;
        padding-left: 0 !important;
        flex-wrap: wrap;
        justify-content: space-between;
        .qrcode-item{
          width: 19.2vw !important;
          height: auto !important;
          margin: 0 !important;
          img{
            width: 100%;
            height: auto;
          }
          .qrcode-text{
            font-size: 3.13vw !important;
            line-height: 3.13vw !important;
            margin-top: 4.533vw !important;
          }
        }
      }
    }
  }

}
@media(max-width: 1560px) {
  .foot-wrap {
    .contact-tel{
      right: -50px !important;
    }
  }

}
.foot-wrap {
  height: 540px;
  width: 100%;
  background: #fcfbec;
  position: relative;
  .beian-text{
    position: absolute;
      font-size: 14px;
      color: #c1c1c1;
      left: 50%;
      transform: translateX(-50%);
      bottom: 12px;
      z-index: 10;
    }

  .md-container {
    height: 100%;
    font-size: 40px;
    font-family: hanli-min,HL0811,Hl0906,Hl1126;
    color: #473935;
    font-weight: lighter;
    line-height: 40px;


    h6 {
      font-weight: lighter;
      font-size: 40px;
      text-align: left;
      margin-bottom: 130px;
      padding-top: 88px;
    }
    .contact-tel{
      position: absolute;
      width: 200px;
      text-align: center;
      line-height: 28px;
      top: 290px;
      right: -119px;
      a{
        color: #473935;
        letter-spacing:3px;
      }
    }
    .qrcode-list {
      display: flex;
      padding-left: 50px;

      .qrcode-item {
        width: 135px;
        height: 135px;
        margin-right: 130px;

        .qrcode-img {
          width: 100%;
        }

        .qrcode-text {
          width: 100%;
          text-align: center;
          margin-top: 26px;
        }
      }
    }


  }
}
</style>
